import { Button } from 'antd';
import * as eva from 'eva-icons';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useMedia } from 'react-use';
import { Globe } from '../../assets/svg';
import { BREAKPOINTS, ROUTES } from '../../common/constants';
import Portal from '../../components/Portal';
import OrganizationTable from './components/OrganizationTable';

const Organizations = () => {
  const history = useHistory();
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  useEffect(() => {
    eva.replace();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <Portal portalId="header-left-content">
        <h1 className="portal-header">
          <div className="d-flex">
            <Globe
              onClick={() => history.push(ROUTES.ORGANIZATION)}
              className="pointer"
            />
          </div>
          Organizations
        </h1>
      </Portal>
      <Portal portalId="header-right-content">
        <Button
          type="primary"
          shape="round"
          onClick={() => history.push(`${ROUTES.ORGANIZATION}/add`)}
        >
          {isDesktopViewport ? 'Add Organization' : 'Add'}
        </Button>
      </Portal>
      <div className="organization-content">
        <div className="organization-table">
          <OrganizationTable />
        </div>
      </div>
    </div>
  );
};

export default Organizations;
